import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoSolicitudPagoDirecto = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoSolicitudPagoDirecto = () => {
  const [loadingGetInfoSolicitudPagoDirecto, setLoadingGetInfoSolicitudPagoDirecto] = useState(false);
  const [successGetInfoSolicitudPagoDirecto, setSuccessGetInfoSolicitudPagoDirecto] = useState(false);
  const [errorGetInfoSolicitudPagoDirecto, setErrorGetInfoSolicitudPagoDirecto] = useState<any>(null);
  const [dataGetInfoSolicitudPagoDirecto, setDataGetInfoSolicitudPagoDirecto] = useState<any>(null);

  const [statusGetInfoSolicitudPagoDirecto, setStatusGetInfoSolicitudPagoDirecto] =
    useState<StatusGetInfoSolicitudPagoDirecto>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudPagoDirecto = async (
    userId: any,
    expedienteId: string = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoSolicitudPagoDirecto(true);
    setSuccessGetInfoSolicitudPagoDirecto(false);
    setErrorGetInfoSolicitudPagoDirecto(null);

    try {
      const res = await apiRecord.getInfoSolicitudPagoDirectoIncapacidadTemporal(userId, expedienteId);

      setStatusGetInfoSolicitudPagoDirecto({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoSolicitudPagoDirecto(true);
      setDataGetInfoSolicitudPagoDirecto(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;
    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetInfoSolicitudPagoDirecto({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoSolicitudPagoDirecto(err);
      console.error("Error en getInfoSolicitudPagoDirecto:", err);

      throw err;

    } finally {
      setLoadingGetInfoSolicitudPagoDirecto(false);
    }
  };

  return {
    getInfoSolicitudPagoDirecto,
    loadingGetInfoSolicitudPagoDirecto,
    successGetInfoSolicitudPagoDirecto,
    errorGetInfoSolicitudPagoDirecto,
    dataGetInfoSolicitudPagoDirecto,
    statusGetInfoSolicitudPagoDirecto
  };
};

export default useGetInfoSolicitudPagoDirecto;
